<div class="innerpage-fullwithbanner">
    <h2 class="bighead">1031 Inquiry</h2>
    <ul class="bread-crumbs">
        <li><a (click)="_validationService.redirect('/')">Home<span>|</span></a></li>
        <li><a href="#" [routerLink]="['/1031-inquiry']" *ngIf="isAdmin">1031 Inquiry<span>|</span></a></li>
        <li>1031 Inquiry Details</li>
    </ul>
</div>
<div class="registration1031 section-margin">
    <div class="container container-lg min-heightcontainer"> 
        <div>
            <!--<div class="row">
                <div class="colg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                   
                </div>
            </div>-->
            <div class="border-div margin0">

                <!--<div class="tabstyle2">
                    <tabset>
                        <tab heading="1031 Trade Dashboard" id="tab1">
                            <div class="bluebg-blocks four margin-bottom-30">
                                <ul class="clearfix">
                                    <li>
                                        <div class="whiteblock">
                                            <h2>XLOI<span style="background:#EC5555"></span></h2>
                                            <h3>$11,000,000</h3>
                                            <h4>2 Properties</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="whiteblock">
                                            <h2>Under Contract<span style="background:#EFC36D"></span></h2>
                                            <h3>$11,000,000</h3>
                                            <h4>2 Properties</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="whiteblock">
                                            <h2>Hard Contract<span style="background:#5BC8AF"></span></h2>
                                            <h3>$11,000,000</h3>
                                            <h4>2 Properties</h4>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="whiteblock">
                                            <h2>Closed Deals<span style="background:#4793EE"></span></h2>
                                            <h3>$11,000,000</h3>
                                            <h4>2 Properties</h4>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="border-div">
                                <h2 class="mainhead"><span class="text">My 1031 Trade</span></h2>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <ul class="trade-details">
                                            <li class="clearfix">
                                                <div class="left">
                                                    <h6>Proceeds</h6>
                                                </div>
                                                <div class="right">
                                                    <h6><span>:</span>$20,000,000</h6>
                                                </div>
                                            </li>
                                            <li class="clearfix">
                                                <div class="left">
                                                    <h6>ID Strategy</h6>
                                                </div>
                                                <div class="right">
                                                    <h6><span>:</span>3 properties</h6>
                                                </div>
                                            </li>
                                        </ul>
                                        <label class="bluelabel margin-bottom-10">Time Remaining</label>
                                        <ul class="trade-details">
                                            <li class="clearfix">
                                                <div class="left">
                                                    <h6>Proceeds</h6>
                                                </div>
                                                <div class="right">
                                                    <h6><span>:</span>$20,000,000</h6>
                                                </div>
                                            </li>
                                            <li class="clearfix">
                                                <div class="left">
                                                    <h6>ID Strategy</h6>
                                                </div>
                                                <div class="right">
                                                    <h6><span>:</span>3 properties</h6>
                                                </div>
                                            </li>
                                        </ul>
                                        <label class="bluelabel margin-bottom-10">Criteria</label>
                                        <ul class="interesttags">
                                            <li>52,000,000 -45,000,000 <span class="icon-close icon"></span></li>
                                            <li>6% CAP <span class="icon-close icon"></span></li>
                                            <li>15 years Term <span class="icon-close icon"></span></li>
                                            <li>Retails <span class="icon-close icon"></span></li>
                                            <li>Investment Grade <span class="icon-close icon"></span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </tab>
                        <tab heading="Trade portfolio">Basic content 1</tab>
                        <tab heading="Offers">Basic content 2</tab>
                        <tab heading="Profile">Basic content 2</tab>
                        <tab heading="Activity Log">Basic content 2</tab>
                    </tabset>

                </div>-->

                <div class="floatinghead clearfix">
                    <h2 class="mainhead"><span class="text">1031 Inquiry Details</span></h2>
                    <button class="right-btn btn  btn-circle btn-green adduserbtn" *ngIf="showEdit" routerLink="/1031-registration/{{exchange1031Id}}" href="#" placement="top" tooltip="Edit Inquiry" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
                    <a class="right-btn btn-border  btn adduserbtn margin-bottom-15 margin-right-10" *ngIf="isAdmin" [routerLink]="['/1031-inquiry']">Back to Inquiry List</a>
                </div>
                <label class="bluelabel  margin-bottom-15">Trader information</label>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">First name</label>
                            <h6 class="displayvalue">{{trade1031InputModel.FirstName}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Last name</label>
                            <h6 class="displayvalue">{{trade1031InputModel.LastName!=null? trade1031InputModel.LastName:'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Email</label>
                            <h6 class="displayvalue">{{trade1031InputModel.Email}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Phone</label>
                            <h6 class="displayvalue">{{trade1031InputModel.Phone | phone}}</h6>
                        </div>
                    </div>
                </div>

                <label class="bluelabel margin-bottom-15">Relinquished Property information</label>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Sold/Projected Sale Date</label>
                            <h6 class="displayvalue">{{trade1031InputModel.Sold_ProjectedSaleDate ? (_validationService.convertUTCDateToLocalDate(trade1031InputModel.Sold_ProjectedSaleDate) | date:'MM/dd/yyyy'):'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Sale Price</label>
                            <h6 class="displayvalue">{{trade1031InputModel.TotalSalePrice!=0?('$ '+ (trade1031InputModel.TotalSalePrice|number)):'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Total Equity</label>
                            <h6 class="displayvalue">{{trade1031InputModel.TotalEquity!=0?('$ '+ (trade1031InputModel.TotalEquity|number)):'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Total Debt</label>
                            <h6 class="displayvalue">{{trade1031InputModel.TotalDebt!=0?('$ '+ (trade1031InputModel.TotalDebt|number)):'-'}}</h6>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Address</label>
                            <h6 class="displayvalue">{{trade1031InputModel.Address!=null ? trade1031InputModel.Address :'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">State</label>
                            <h6 class="displayvalue">{{trade1031InputModel.StateName!=null?trade1031InputModel.StateName:'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">City</label>
                            <h6 class="displayvalue">{{trade1031InputModel.CityName!=null ? trade1031InputModel.CityName :'-'}}</h6>
                        </div>
                    </div>
                </div>

                <label class="bluelabel margin-bottom-15">Interested Property Type(s)</label>
                <div class="form-group">
                    <h6 class="displayvalue">{{trade1031InputModel.PropertyTypes!=null ? trade1031InputModel.PropertyTypes :'-'}}</h6>
                </div>
                <label class="bluelabel margin-bottom-15">Geography</label>
                <div class="form-group">
                    <h6 class="displayvalue">{{trade1031InputModel.GeographyTypes!=null ? trade1031InputModel.GeographyTypes :'-'}}</h6>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Strategy</label>
                            <h6 class="displayvalue">{{trade1031InputModel.StrategyText ? trade1031InputModel.StrategyText : '-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Expected Cap Rate</label>
                            <h6 class="displayvalue">{{(_validationService.IsNullAndAddSuffix(trade1031InputModel.CapRateMin|number,'',' % - ')+_validationService.IsNullAndAddSuffix(trade1031InputModel.CapRateMax|number,'',' %'))?(_validationService.IsNullAndAddSuffix(trade1031InputModel.CapRateMin|number,'',' % - ')+_validationService.IsNullAndAddSuffix(trade1031InputModel.CapRateMax|number,'',' %')):'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Expected Rent/NOI</label>
                            <h6 class="displayvalue">{{(_validationService.IsNullAndAddPrefixAndSuffix(trade1031InputModel.RentMin|number,'','$ ',' - ')+_validationService.IsNullAndAddPrefix(trade1031InputModel.RentMax|number,'','$ '))?(_validationService.IsNullAndAddPrefixAndSuffix(trade1031InputModel.RentMin|number,'','$ ',' - ')+_validationService.IsNullAndAddPrefix(trade1031InputModel.RentMax|number,'','$ ')):'-'}}</h6>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Preferred Exchange Location</label>
                            <h6 class="displayvalue">{{selectedExchangeLocation ? selectedExchangeLocation: '-'}}</h6>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Initial Comments</label>
                            <h6 class="displayvalue">{{trade1031InputModel.SpecificPreferences ? trade1031InputModel.SpecificPreferences : '-'}}</h6>
                        </div>
                    </div>
                </div>

            </div>
            <!--<div class="text-right">
                <button class="btn btn-default btn-lg" (click)="onCancel();">Back</button>
            </div>-->
        </div>
    </div>
</div>